import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, filter, Observable, tap } from 'rxjs';
import { ConfirmDialog } from '../common/interfaces/confirm-dialog.interface';
import { ConfirmComponent } from '../components/dialogs/confirm/confirm.component';
import { ActiveFounderDetailsComponent } from '../components/mentor/dialogs/active-founder-details/active-founder-details.component';
import { MentorConnectedUser } from '../interfaces/responsedata.ts/mentor';

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    public isDialogOpen$ = new BehaviorSubject<boolean>(false);

    private dialog = inject(MatDialog);

    public openConfirmationDialog$(data: ConfirmDialog): Observable<boolean> {
        const dialog = this.dialog.open(
            ConfirmComponent,
            {
                panelClass: 'small-dialog',
                data,
                disableClose: true,
                autoFocus: false,
            },
        );

        return this.openDialog$<ConfirmComponent, boolean>(dialog)
        // .pipe(
        //     filter((confirmed) => confirmed === true),
        // );
    }

    public openFounderDetailsDialog$(activeFounder: MentorConnectedUser): Observable<{ revoked?: boolean }> {
        const dialog = this.dialog.open(
            ActiveFounderDetailsComponent,
            {
                data: { activeFounder },
                disableClose: true,
                minWidth: '80vw',
                height: '80vh',
                autoFocus: false,
            }
        );

        return this.openDialog$<ActiveFounderDetailsComponent, { revoked?: boolean }>(dialog)
            .pipe(
                filter((data: { revoked?: boolean }) => data?.revoked === true),
            );
    }

    private openDialog$<T, R>(
        dialog: MatDialogRef<T>,
    ): Observable<R> {
        this.isDialogOpen$.next(true);

        return dialog.afterClosed()
            .pipe(
                tap(() => this.isDialogOpen$.next(false)),
            );
    }
}
